var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaFreeEntryPointWindowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 1.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 8,
    strokeDasharray: "37 14",
    transform: "rotate(38 10.5 10.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1 7.9c-.4-.8-1.4-1.2-2.6-1.2-1.5 0-2.5.7-2.5 1.8 0 1 .8 1.5 2.5 1.9s2.6.9 2.6 2c0 1.2-1.1 1.9-2.6 1.9-1.3 0-2.3-.5-2.7-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6 13.6v6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9 17.7l2.7 2.7 2.7-2.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaFreeEntryPointWindowIcon);
export default __webpack_public_path__ + "static/media/meta_free_entry_point_window_icon.6eb02fe2.svg";
export { ForwardRef as ReactComponent };